import SettingConfig from '@module/config/setting';
import type { ParsedPublicMessage } from '@module/types/centrifuge/messageTypes';
import { isRoomEndMessage, type RoomEndMessage } from '@module/types/centrifuge/public-message/etcMessageTypes';
import type { MessageHandler, MessageHandlerAction, MessageHandlerContext } from '../types';

export class RoomEndHandler implements MessageHandler {
  constructor(
    private customAction?: MessageHandlerAction<RoomEndMessage> | Promise<MessageHandlerAction<RoomEndMessage>>,
  ) {}

  canHandle(payload: ParsedPublicMessage): boolean {
    return isRoomEndMessage(payload);
  }

  async handle(payload: RoomEndMessage, context: MessageHandlerContext): Promise<void> {
    if (this.customAction === null || this.customAction === undefined) return;

    if (typeof this.customAction === 'function') {
      this.customAction(payload, context);
      return;
    }

    if (typeof this.customAction === 'object' && 'then' in this.customAction) {
      const resolvedAction = await this.customAction;
      if (typeof resolvedAction === 'function') {
        resolvedAction(payload, context);
        return;
      }
    }

    // 기본 동작

    context.dispose?.();
    context.disconnectSocket?.();

    const message = SettingConfig.isFanza ? '配信が終了しました。' : '방송이 종료되었습니다.';

    if (context.hsms) {
      const isMobile = SettingConfig.isMoWeb;
      await context.hsms.openModal(
        'Confirm',
        { title: message, isShowCancelButton: false, confirmText: '確認' },
        isMobile ? { size: 'sm', density: 'tight' } : { size: 'mid' },
      );
      context.router?.push('/');
    } else if (context.pushModal) {
      context.pushModal({
        type: 'CONFIRM_MODAL',
        options: {
          description: message,
          onClose: () => {
            context.clearModals?.();
            context.router?.push('/');
          },
        },
      });
    }
  }
}
